import React from 'react';
import { forYou, notForYou } from '../data/mock';
import { Check, X } from 'lucide-react';

const WhoItsForSection = () => {
  return (
    <section id="who-its-for" className="py-16 md:py-24 bg-violet-50/30">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <span className="text-fuchsia-500 font-semibold text-sm uppercase tracking-wide">
            Right Fit
          </span>
          <h2 className="text-3xl md:text-4xl font-bold text-slate-800 mt-2 mb-4">
            Is NurseBloc <span className="text-nursebloc-gradient">Right for You?</span>
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            We're not for everyone, and that's okay. Here's how to know if we can help.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8">
          {/* This is for you */}
          <div className="bg-white rounded-3xl p-8 border border-violet-100 shadow-sm hover:shadow-md transition-shadow">
            <div className="flex items-center gap-3 mb-6">
              <div className="w-12 h-12 bg-violet-100 rounded-xl flex items-center justify-center">
                <Check className="w-6 h-6 text-violet-600" />
              </div>
              <h3 className="text-xl font-bold text-slate-800">NurseBloc is for you if...</h3>
            </div>
            <ul className="space-y-4">
              {forYou.map((item, index) => (
                <li key={index} className="flex items-start gap-3">
                  <div className="w-5 h-5 mt-0.5 btn-nursebloc rounded-full flex items-center justify-center flex-shrink-0">
                    <Check className="w-3 h-3 text-white" />
                  </div>
                  <span className="text-slate-700">{item}</span>
                </li>
              ))}
            </ul>
          </div>

          {/* This is not for you */}
          <div className="bg-white rounded-3xl p-8 border border-gray-100 shadow-sm hover:shadow-md transition-shadow">
            <div className="flex items-center gap-3 mb-6">
              <div className="w-12 h-12 bg-gray-100 rounded-xl flex items-center justify-center">
                <X className="w-6 h-6 text-gray-500" />
              </div>
              <h3 className="text-xl font-bold text-slate-800">NurseBloc is not...</h3>
            </div>
            <ul className="space-y-4">
              {notForYou.map((item, index) => (
                <li key={index} className="flex items-start gap-3">
                  <div className="w-5 h-5 mt-0.5 bg-gray-300 rounded-full flex items-center justify-center flex-shrink-0">
                    <X className="w-3 h-3 text-white" />
                  </div>
                  <span className="text-gray-600">{item}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhoItsForSection;
